module.exports = __webpack_public_path__ + "img/030.d72439f0.jpg";